export default __webpack_public_path__ + "static/media/base-report20.a02e9893.png";